// extracted by mini-css-extract-plugin
export default {"container":"rG-z","innerContainer":"sG-z","multipleLines":"tG-z","heading":"uG-z","content":"vG-z","linkColor":"wG-z"};